import useLanguage from "../i18n/useLanguage";

export default function TechStackRow({ title, icons, isVisible }) {
  const { t } = useLanguage();
  return (
    <div className="flex items-center justify-center gap-10">
      {/* Title */}
      <div className="text-right leading-tight min-w-[160px]">
        <div className="text-3xl font-bold">{t(title[0])}</div>
        <div className="text-3xl font-bold">{t(title[1])}</div>
      </div>

      {/* Divider */}
      <div className="w-[2px] h-20 bg-white/80" />

      {/* Icons */}
      <div className="relative overflow-hidden w-[360px]">
        {/* width 360px = 3 icon kelihatan */}
        <div
          className={`
            flex gap-12 w-max
            animate-slide
            ${!isVisible ? "animate-paused" : ""}
          `}
        >
          {[...icons, ...icons].map((Icon, i) => (
            <Icon
              key={i}
              className="text-5xl text-white/80 hover:text-amber-300 transition-colors"
            />
          ))}
        </div>
      </div>
    </div>
  );
}
